import React from 'react';
import { Route, Router, Switch } from 'react-router';

import { browserHistory } from './utils/historyUtil';
import ForbiddenPage from './pages/errors/ForbiddenPage';

function ErrorApp(): JSX.Element {
  return (
    <Router history={browserHistory}>
      <Switch>
        <Route path="/errors/forbidden">
          <ForbiddenPage />
        </Route>
      </Switch>
    </Router>
  );
}

export default ErrorApp;
